<div mat-dialog-title class="header">
  <div class="font-headline-4">
    {{ 'verify-email-dialog.title' | translate }}
  </div>
  <span
    class="material-symbols-outlined close-icon cursor-pointer color-text-black"
    [mat-dialog-close]="false"
  >
    close
  </span>
</div>
<div mat-dialog-content class="content d-flex flex-column">
  <div class="d-flex justify-content-around address-change-selectors">
    <div>{{ 'verify-email-dialog.action' | translate }}</div>
    <div>
      <mat-button-toggle-group [value]="changeEmailAddress" (change)="toggleChangeEmailAddress()">
        <mat-button-toggle [value]="false">{{
          'verify-email-dialog.buttons.current-address' | translate
        }}</mat-button-toggle>
        <mat-button-toggle [value]="true">{{
          'verify-email-dialog.buttons.new-address' | translate
        }}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div *ngIf="actionForm">
    <form [formGroup]="actionForm" #f="ngForm">
      <div
        class="d-flex"
        [class.justify-content-center]="!changeEmailAddress"
        [class.justify-content-around]="changeEmailAddress"
      >
        <div class="mat-form-field-container inputs">
          <span class="fake-label m3-label-large" *ngIf="!changeEmailAddress">{{
            'verify-email-dialog.options.current-address' | translate
          }}</span>
          <span class="fake-label m3-label-large" *ngIf="changeEmailAddress">{{
            'verify-email-dialog.options.new-address' | translate
          }}</span>
          <mat-form-field class="input-full-width">
            <mat-label></mat-label>
            <input
              matInput
              formControlName="email"
              name="email"
              autocomplete="on"
              type="email"
              [readonly]="!changeEmailAddress"
            />
            <mat-error *ngIf="actionForm.controls.email.hasError('required')">
              {{ 'form.error.fieldRequired' | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                actionForm.controls.email.hasError('email') ||
                actionForm.controls.email.hasError('pattern')
              "
            >
              {{ 'form.error.typeEmail' | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                actionForm.controls.email.hasError('email') ||
                actionForm.controls.email.hasError('pattern')
              "
            >
              {{ 'form.error.typeEmail' | translate }}
            </mat-error>
            <mat-error *ngIf="actionForm.controls.email.hasError('valueEqualTo')">
              {{ 'verify-email-dialog.form.error.new-email-equals-current' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="mat-form-field-container password-field-container" *ngIf="changeEmailAddress">
          <span class="fake-label m3-label-large">{{
            'verify-email-dialog.form.confirm-password' | translate
          }}</span>
          <mat-form-field class="input-full-width">
            <mat-label></mat-label>
            <input
              appAutofocus
              matInput
              formControlName="password"
              name="password"
              trim="blur"
              [type]="hidePassword ? 'password' : 'text'"
              autocomplete="on"
              placeholder="{{
                'verify-email-dialog.form.placeholders.current-password' | translate
              }}"
            />
            <div matSuffix style="display: flex">
              <button
                mat-icon-button
                type="button"
                (click)="hidePassword = !hidePassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hidePassword"
                matTooltip="{{
                  hidePassword
                    ? ('password.field.show.button.tooltip' | translate)
                    : ('password.field.hide.button.tooltip' | translate)
                }}"
                matTooltipClass="custom-tooltips"
              >
                <span class="material-symbols-outlined">
                  {{ hidePassword ? 'visibility_off' : 'visibility' }}
                </span>
              </button>
            </div>
            <mat-error *ngIf="actionForm.controls.password.hasError('required')">
              {{ 'form.error.fieldRequired' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions class="buttons-list">
  <button
    type="button"
    mat-flat-button
    class="font-button color-feedback-action-action button-fixed-height"
    (click)="deny()"
    cdkFocusInitial
  >
    <span class="btn-text">{{ 'buttons.cancel' | translate }}</span>
  </button>
  <button
    type="button"
    mat-flat-button
    color="primary"
    class="button-primary font-button button-action-detail button-fixed-height"
    (click)="requestActionToken()"
    [disabled]="!actionForm.valid"
  >
    <span class="btn-text">{{ 'buttons.sendEmail' | translate }}</span>
  </button>
</div>
